<template>
  <button
    type="button"
    :class="['btn', `btn-${variant}`, 'compare-btn', comparisonStore.isCurrentlySelected(vehicleId) ? 'selected' : '']"
    @click="addOrRemoveCarToCompare"
    :disabled="disableAddToCompare"
  >
    <img class="compare-btn__compare-icon" :alt="compareIconAltText" />{{ compareLabel }}
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useCarComparisonStore } from '../../foundation/stores/carComparisonStore';

const comparisonStore = useCarComparisonStore();

const props = defineProps({
  vehicleId: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    default: 'secondary',
  },
});

function addOrRemoveCarToCompare() {
  if (comparisonStore.isCurrentlySelected(props.vehicleId)) {
    const indexToRemove = comparisonStore.selectedVehicleIds.findIndex((item: string) => item === props.vehicleId);

    comparisonStore.removeCarToCompare(indexToRemove, false);
  } else {
    comparisonStore.addCarToCompare(props.vehicleId);
  }
}

const compareIconAltText = computed(() => {
  return comparisonStore.isCurrentlySelected(props.vehicleId) ? 'An icon with a minus inside a circle.' : 'An icon with a plus inside a circle.';
});

const disableAddToCompare = computed(() => {
  return !comparisonStore.isCurrentlySelected(props.vehicleId) && comparisonStore.hasReachedMaxLimit;
});

const compareLabel = computed(() => {
  return comparisonStore.isCurrentlySelected(props.vehicleId) ? 'Remove' : 'Compare';
});
</script>

<style lang="scss" scoped>
.compare-btn {
  width: 195px;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  height: 2.5rem;

  .compare-btn__compare-icon {
    content: url(@/assets/img/add-to-compare.svg);
  }

  &:disabled {
    .compare-btn__compare-icon {
      content: url(@/assets/img/add-to-compare-disabled.svg);
    }
  }

  &.selected {
    .compare-btn__compare-icon {
      content: url(@/assets/img/remove-from-compare.svg);
    }

    &.btn-primary {
      background-color: $racq-dark-blue;
      color: #fff;
    }

    &:hover {
      background-color: $racq-button-highlight-color;
      color: $racq-true-white;
      .compare-btn__compare-icon {
        content: url(@/assets/img/remove-from-compare.svg);
      }
    }

    &:focus {
      outline: 2px dashed $racq-navy;
    }

    &:active {
      background-color: $racq-dark-blue;
      outline: 2px dashed $racq-navy;
    }
  }
}
</style>
